@if (hasConfiguration) {
  <form [formGroup]="form">
    <mat-form-field
      appearance="outline"
      subscriptSizing="dynamic"
      floatLabel="always">
      @if (hasLabel) {
        <mat-label>{{ label() }}</mat-label>
      }
      <mat-select
        formControlName="paramValue"
        hideSingleSelectionIndicator
        panelClass="qaroni-filter-panel"
        (selectionChange)="onchange($event)"
        [multiple]="multiple()">
        @if (showTextFilter()) {
          <div class="select-search-container">
            <mat-form-field
              appearance="outline"
              subscriptSizing="dynamic"
              class="search-field">
              <input
                matInput
                [formControl]="searchControl"
                [placeholder]="searchPlaceholder()"
                (keydown)="$event.stopPropagation()"
                (click)="$event.stopPropagation()" />
            </mat-form-field>
          </div>
        }

        @if (showFirstOption()) {
          <mat-option
            class="border-b font-medium"
            [value]="firstOptionValue()"
            >{{ firstOption() }}</mat-option
          >
        }

        @for (option of filteredOptions; track getValue(option)) {
          <mat-option [value]="getValue(option)">
            {{ getText(option) }}
          </mat-option>
        }

        @if (filteredOptions.length === 0 && showTextFilter()) {
          <div
            class="flex items-center justify-center p-5 text-sm text-gray-400">
            No se encontraron resultados
          </div>
        }
      </mat-select>
    </mat-form-field>
  </form>
}
